import { Navigate } from "react-router-dom";

const Login = () => {
  return <Navigate to="/auth" replace />;
};

export default Login;
